<app-wizard-step-card [header]="'TELECOM.INTEREST.TITLE' | translate" [formGroup]="form" (next)="onNext()">
    <app-select-input
        [options]="telecomInterestOptions"
        [label]="'TELECOM.INTEREST.DESCRIPTION' | translate"
        [hasMargin]="false"
        [hasMarginDouble]="true"
        [formControlName]="controlNames.Interest"
        [attr.data-testid]="'telecom-interest-input'"
    ></app-select-input>

    <p>{{ 'TELECOM.INTEREST.PROVIDERS' | translate }}</p>
    <div
        class="u-w100p u-flex-responsive u-margin-top u-margin-bottom-double u-flex-align-items-center u-flex-justify-content-center-up-to-and-including-phone-landscape"
    >
        <img
            *ngFor="let provider of providers"
            class="u-margin-right-double-phone-landscape-up u-margin-bottom-up-to-and-including-phone-landscape h-[38px]"
            [src]="supplierAssets + '/' + provider + '.png' | lowercase"
            width="auto"
            [alt]="provider"
        />
    </div>
</app-wizard-step-card>
